export const getAmountTextColor = (amount: number) => {
  return {
    'text-bittersweet-600': amount < 0,
    'text-green-700': amount > 0,
    'text-obsidian-500': amount === 0,
  };
};
